var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14.821mm",
    height: "12.614mm",
    viewBox: "0 0 14.821 12.614",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath858"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400.12 394.24h42.012v35.755h-42.012z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath864"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath868"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath872"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath876"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m407 420h19v9h-19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath880"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m407.55 420.42h18.03v8.3694h-18.03z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath884"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath888"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m421 409h5v19h-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath892"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m421.94 409.14h3.7768v17.915h-3.7768z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath896"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m407 409h16v14h-16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath904"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m407.55 409.17h14.926v13.485h-14.926z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath908"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath912"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m411 411h19v10h-19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath916"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m411.91 411.71h18.03v8.3693h-18.03z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath920"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath924"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426 401h5v18h-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath928"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426.3 401.32h3.7769v17.03h-3.7769z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath932"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath936"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m411 401h16v13h-16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath940"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m411.91 401.35h14.926v12.6h-14.926z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath948"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m428 409h11v6h-11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath952"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m428.39 409.11h9.8445v5.5705h-9.8445z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath956"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath960"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436 403h3v11h-3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath964"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436.66 403.55h1.6334v9.9826h-1.6334z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath968"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath972"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m428 403h9v8h-9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath976"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m428.39 403.57h8.5019v7.0338h-8.5019z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath980"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath984"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m427 418h10v6h-10z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath988"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m427.02 418.13h9.8445v5.154h-9.8445z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath992"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath996"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m435 412h2v11h-2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m435.29 412.42h1.6334v9.8933h-1.6334z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1004"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 394h43v36h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1008"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m427 412h9v8h-9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1012"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m427.02 412.44h8.5019v6.7661h-8.5019z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-76.031 -110.18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -65.124 261.87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath858)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath864)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath868)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#a1c74a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m408.16 411.97-0.1639 0.1313 0.1792 0.2235 0.1638-0.1313zm-1.5749-1.9655-0.1638 0.1313 0.7874 0.9827 0.1638-0.1313zm-1.5749-1.9654-0.1638 0.1313 0.7874 0.9827 0.1639-0.1313zm-1.5748-1.9654-0.1638 0.1313 0.7874 0.9827 0.1638-0.1313zm-1.5748-1.9653-0.1638 0.1313 0.7874 0.9826 0.1638-0.1312zm-1.5749-1.9654-0.1639 0.1313 0.7874 0.9826 0.164-0.1313z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.08 419.54-5.2289 0.7225 0.0288 0.208 5.2289-0.7225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.18 421.49-2.5272 0.3493 0.0215 0.156 2.5272-0.3493z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#bcbcbc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m434.63 394.8c0.0189-2e-3 0.0378-4e-3 0.0568-6e-3 -0.019 2e-3 -0.0379 4e-3 -0.0568 6e-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.84 394.78c0.0105-3e-3 0.0208-6e-3 0.0313-8e-3 -0.0105 3e-3 -0.0208 6e-3 -0.0313 8e-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.76 394.78c0.0106-3e-4 0.021-5e-4 0.0316-9e-4 -0.0106 4e-4 -0.021 6e-4 -0.0316 9e-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.73 394.92c0.013 5e-3 0.026 0.01 0.0389 0.0145 0.0197-7e-3 0.0393-0.0133 0.0589-0.0199-2e-3 -8e-3 -4e-3 -0.0157-7e-3 -0.0236-0.0304 0.01-0.0609 0.0193-0.0913 0.029"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m408.91 421.55c-0.0288-0.0166-0.0576-0.0333-0.0864-0.05 0.0288 0.0167 0.0576 0.0334 0.0864 0.05",
    fill: "#b22e4c"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath872)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath876)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m421.94 420.42-14.388 2.2395 4.9175 6.1297 13.113-1.7314z",
    fill: "#a1c74a"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath884)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath888)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m421.94 420.42 0.5108-11.278 3.2661 9.428-0.1347 8.4875z",
    fill: "#1ea365"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath896)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath900)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m421.94 420.42-14.388 2.2395 0.7649-11.214 14.161-2.2713z",
    fill: "#a1c74a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m413.77 410.11c-0.0288-0.0167-0.0577-0.0333-0.0865-0.05 0.0288 0.0167 0.0577 0.0333 0.0865 0.05",
    fill: "#b22e4c"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath908)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath912)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426.3 411.71-14.388 2.2395 4.9175 6.1298 13.113-1.7314z",
    fill: "#70bde5"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath920)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath924)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426.3 411.71 0.5107-10.392 3.2662 6.5109-0.1348 10.52z",
    fill: "#4993c1"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath932)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath936)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426.3 411.71-14.388 2.2395 0.7649-10.329 14.16-2.2713z",
    fill: "#70bde5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m411.72 413.55-0.1633 0.1317 0.2705 0.3354 0.1634-0.1317zm-1.5812-1.9602-0.1634 0.1318 0.7906 0.98 0.1635-0.1317zm15.602-1.0126-0.1802 0.1078 0.6461 1.0807 0.1802-0.1077zm-17.184-0.9476-0.1634 0.1317 0.7905 0.9802 0.1635-0.1317zm15.891-1.2142-0.1802 0.1078 0.6462 1.0808 0.1801-0.1077zm-17.14-0.6178-0.4425 0.0688 0.7378 0.9148 0.1635-0.1317-0.5095-0.6315 0.083-0.013zm2.4885-0.3872-1.2443 0.1935 0.0323 0.2074 1.2443-0.1936zm2.4887-0.3875-1.2443 0.1937 0.0323 0.2074 1.2443-0.1937zm2.4884-0.3872-1.2443 0.1936 0.0323 0.2074 1.2443-0.1936zm8.3825-0.3819-0.1801 0.1077 0.6462 1.081 0.1802-0.1078zm-5.8939-6e-3 -1.2442 0.1937 0.0323 0.2074 1.2442-0.1936zm2.4885-0.3872-1.2443 0.1937 0.0324 0.2073 1.2442-0.1936zm2.4886-0.3874-1.2442 0.1937 0.0323 0.2075 1.2442-0.1938z",
    fill: "#4993c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.96 396.86 15.133-2.4275-0.572 11.026-15.375 2.3931zm15.3-2.6137-15.448 2.478-0.8378 11.314 0.0978-0.0152 15.6-2.428z",
    fill: "#4993c1"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath944)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath948)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436.66 409.11-8.2695 1.4906 2.1267 4.0798 7.7178-1.1524z",
    fill: "#70bde5"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath956)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath960)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436.66 409.11 0.2209-5.5645 1.4125 4.3335-0.0584 5.649z",
    fill: "#4993c1"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath968)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath972)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436.66 409.11-8.2695 1.4906 0.3308-5.5221 8.1711-1.5117z",
    fill: "#70bde5"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath980)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath984)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m435.29 418.13-8.2695 1.0741 2.1266 4.0799 7.7179-0.974z",
    fill: "#4993c1"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath992)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath996)",
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m435.29 418.16 0.2209-5.743 1.4124 4.0657-0.0583 5.8275z",
    fill: "#175583"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1004)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1008)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m435.29 418.13-8.2695 1.0741 0.3308-5.522 8.1711-1.2441z",
    fill: "#4993c1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m426.75 401-0.1862 0.0965 0.3643 0.7025 0.1863-0.0966zm-1.1598-2.2357-0.1862 0.0966 0.5798 1.1178 0.1863-0.0966zm-1.1599-2.2356-0.1862 0.0967 0.58 1.1178 0.1862-0.0968zm-1.1596-2.2356-0.1864 0.0967 0.58 1.1178 0.1863-0.0968z",
    fill: "#4993c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.29 402.93-0.1289 0.0904 0.4518 0.6448 0.1289-0.0903zm-1.4449-2.0629-0.129 0.0904 0.7226 1.0315 0.1289-0.0904zm-1.4449-2.0628-0.1289 0.0904 0.7224 1.0313 0.1289-0.0903zm-1.4449-2.0628-0.1289 0.0904 0.7224 1.0314 0.129-0.0904z",
    fill: "#4993c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.75 418.22-0.1996 0.0646 0.388 1.1979 0.1996-0.0646zm-0.776-2.396-0.1997 0.0646 0.388 1.198 0.1998-0.0647zm-0.7761-2.396-0.1997 0.0647 0.3881 1.1979 0.1996-0.0646zm-0.776-2.396-0.1996 0.0646 0.3879 1.1981 0.1997-0.0647zm-0.776-2.3959-0.1998 0.0646 0.388 1.1981 0.1998-0.0648zm-0.7762-2.396-0.1996 0.0647 0.388 1.1979 0.1996-0.0647zm-0.776-2.396-0.1997 0.0646 0.3881 1.1981 0.1997-0.0647zm-0.776-2.3959-0.1998 0.0646 0.3881 1.1981 0.1997-0.0648zm-0.7761-2.396-0.1996 0.0646 0.3879 1.198 0.1997-0.0647zm-0.776-2.396-0.1998 0.0646 0.3882 1.1981 0.1996-0.0646z",
    fill: "#a1c74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.65 396.59-34.458 5.5193 0.0333 0.207 34.457-5.5191z",
    fill: "#a1c74a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#175583"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440.7 425.82-0.1955 0.0765 0.4594 1.1724 0.1955-0.0764zm-0.9187-2.345-0.1956 0.0766 0.4595 1.1724 0.1955-0.0765zm-0.9187-2.3449-0.1956 0.0765 0.4593 1.1725 0.1956-0.0766zm-0.9189-2.345-0.1955 0.0766 0.4594 1.1724 0.1956-0.0765zm-0.9187-2.345-0.1955 0.0766 0.4594 1.1725 0.1955-0.0766z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.25 427.45-19.982 2.3408 0.0245 0.2085 19.982-2.3408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.14 429.58-0.156 0.1407 0.2223 0.2463 0.156-0.1406zm-1.687-1.8699-0.1559 0.1406 0.8435 0.9349 0.1559-0.1406z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.7a942be080551a794cca80ca5ac16812.svg";
export { ForwardRef as ReactComponent };